import { PartRelationshipGraph } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import { useQuery } from '@tanstack/react-query';

export const PART_RELATIONSHIP_GRAPH_QUERY_KEY = 'partFinderReport.relationships';

export const useGetPartRelationshipGraph = (reportId: string) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useQuery<PartRelationshipGraph, AxiosApiError>({
    queryKey: [PART_RELATIONSHIP_GRAPH_QUERY_KEY, reportId],
    queryFn: async () => {
      const response = await api.tenants.getPartFinderReportRelationships(tenantId, reportId);
      return response.data.partRelationshipGraph;
    },
    enabled: !!reportId && !!tenantId,
  });
};
